import React, { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Clock, Gauge, UserCircle2, MessageCircle, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const STEPS = [
  { icon: Sparkles, t: "ob_t1", d: "ob_d1", color: "#007BFF" },
  { icon: Clock, t: "ob_t2", d: "ob_d2", color: "#00E676" },
  { icon: Gauge, t: "ob_t3", d: "ob_d3", color: "#007BFF" },
  { icon: UserCircle2, t: "ob_t4", d: "ob_d4", color: "#00E676" },
  { icon: MessageCircle, t: "ob_t5", d: "ob_d5", color: "#007BFF" },
];

export default function OnboardingTour({ open, onClose }) {
  const { t } = useI18n();
  const [step, setStep] = useState(0);

  useEffect(() => { if (open) setStep(0); }, [open]);

  const s = STEPS[step];
  const Icon = s.icon;
  const isLast = step === STEPS.length - 1;

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-[#111111] border border-white/10 text-white rounded-[16px] max-w-md p-0 overflow-hidden" data-testid="onboarding-dialog">
        <DialogTitle className="sr-only">{t(s.t)}</DialogTitle>
        <div className="p-6">
          <div className="w-14 h-14 rounded-2xl flex items-center justify-center mb-4"
            style={{ background: `${s.color}1A`, border: `1px solid ${s.color}55` }}>
            <Icon size={26} style={{ color: s.color }} />
          </div>
          <h2 className="font-display text-2xl font-extrabold mb-2" data-testid="onboarding-title">{t(s.t)}</h2>
          <p className="text-white/60 text-sm leading-relaxed min-h-[72px]">{t(s.d)}</p>

          <div className="flex items-center gap-1.5 mt-5">
            {STEPS.map((_, i) => (
              <span key={i} className="h-1.5 rounded-full transition-all"
                style={{ width: i === step ? 22 : 7, background: i === step ? s.color : "rgba(255,255,255,0.2)" }} />
            ))}
          </div>

          <div className="flex items-center justify-between mt-6">
            {step > 0 ? (
              <button data-testid="onboarding-back" onClick={() => setStep((v) => v - 1)}
                className="text-sm text-white/50 hover:text-white transition-colors">{t("ob_back")}</button>
            ) : (
              <button data-testid="onboarding-skip" onClick={onClose}
                className="text-sm text-white/40 hover:text-white transition-colors">{t("ob_skip")}</button>
            )}
            <Button data-testid="onboarding-next"
              onClick={() => (isLast ? onClose() : setStep((v) => v + 1))}
              className="bg-[#007BFF] hover:bg-[#0056b3] rounded-[12px] h-10 px-6 font-semibold">
              {isLast ? t("ob_done") : t("ob_next")}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
